import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationExtras,
  Params,
  Router,
} from '@angular/router';

import * as $ from 'jquery';

import { MainService } from '../../services/main.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
})
export class ServiceComponent implements OnInit {
  API = this.helper.getApi();
  questionMark = 'assets/icons/info.svg';
  active_step = 'service';
  vals = {};
  formElements = [];
  data = {};
  availableServices = [];
  filteredServices = [];
  clinicalExperts = [];
  allTherapists = [];
  dropdownSelection: string;
  dropdownSelection2: string;
  interval: any;
  fService: any;
  selectedId = undefined;
  query = {};
  clinics = [];
  bookingClinics = [];
  referral: any;
  first_booking_text: any;
  bookingIsExpert: string;
  bookingTherapist: any;
  availableTherapists = [];
  selectedTherapists = [];
  selectedTherapist = '';
  clinicId: string;
  bookings: number;
  isFysio: boolean;
  selectedClinic: any;
  selectedDate: Date;
  selectedDate2: string;
  token: string;
  flowType: string;
  fisiqClinics: boolean;
  preselected_therapist: string;
  superClinicId: string;
  preselected_clinic: string;
  singleClinic: string;
  preSelectedService: string;
  hideInsurance = false;
  services: boolean;
  haveTherapists: boolean;
  noExperts: string;
  noBodyParts: string;
  showReferral = false;
  duration: number;
  firstTime = false;
  currentUser: any = this.helper.getStorage("currentUser");
  expertTherapist: any = this.helper.getStorage("expertTherapist");
  clinicTherapists: any = this.helper.getStorage("clinicTherapists")
  allClinics: Array<any> = this.helper.getStorage("allClinics")
  allBookings: Array<any> = this.helper.getStorage("bookings")
  selectedService: string = this.helper.getStorage("selectedService")
  readonly flowName: any = Constants.FLOW_TYPE;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public mainService: MainService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.clinicId = Array.isArray(params.clinics)
        ? params.clinics[0]
        : params.clinics;

      if (params.type) {
        this.flowType = params.type;
      }

      if (params.type === this.flowName.aalborg) {
        this.hideInsurance = true;
      }
    });

    if (Array.isArray(this.clinicTherapists)) {
      this.bookingTherapist = this.clinicTherapists;
    } else {

      if (this.bookingTherapist) {
        this.bookingTherapist.push(this.clinicTherapists);
      }
    }

    this.route.queryParams.subscribe((query) => {
      this.paramActions(query);
    });

    const data = this.data;
    const formElements = [
      {
        key: 'insuranceCompany',
        controlType: 'dropdown',
        value: data['insuranceCompany'],
      },
    ];

    formElements.map((el) => (this.vals[el.key] = el.value));

    this.formElements = formElements;

    this.selectedClinic = this.allClinics.filter(
      (el) => el.id === this.clinicId
    );
    this.referral = this.selectedClinic[0].referral;
    //this.first_booking_text = this.selectedClinic[0].first_time_booking_text;
    let textItem = _.find(this.selectedClinic[0].booking_texts, t => t.step === 'step_consultation' && t.step_context === 'ctx_first_booking'&& t.text_type === 'content');
    if (textItem && textItem.text)
      this.first_booking_text = textItem.text;
  }

  paramActions(query) {
    this.query = query;
    this.clinics.push(query.clinics);

    this.route.queryParams.subscribe((params: Params) => {
      this.singleClinic = params['singleClinic'];
      this.superClinicId = params['superClinicId'];
      this.bookingClinics = params['clinics'];
      this.bookingIsExpert = params['isExpert'];
      this.bookingTherapist = this.clinicTherapists
        ? this.clinicTherapists.toString().toLowerCase()
        : null;
      this.dropdownSelection = params['behandling'];
      this.bookings = params['bookings'];
      this.fService = params['service'];
      this.noExperts = params['noExperts'];
      this.noBodyParts = params['noBodyParts'];

      if (params['bookingToken']) {
        this.token = params['bookingToken'];
      }

      if (params['type'] === 'fysiq' || params['type'] === this.flowName.aalborg) {
        this.fisiqClinics = true;
      }

      if (this.clinicTherapists && this.clinicTherapists.length > 0) {
        this.haveTherapists = true;
      } else {
        this.haveTherapists = false;
      }

      this.preselected_therapist = params['preselected_therapist'];
    });

    this.getTherapistServices();
    this.getAvailableServices();
  }

  preselectService(services) {

    if (services && services.length > 0) {
      this.services = true;

      if (this.selectedService) {
        const preselected = services.find(
          (service) => service.service_name === this.selectedService
        );

        if (preselected) {

          if (preselected.is_fk === 0) {
            this.setDropdownSelection(this, preselected);
          }

          this.selectedService = preselected;
          this.preSelectedService = preselected.service_name;
        }
      }
    } else {
      this.services = false;
    }
  }

  bookVisit() {
    const params = {
        clinics: this.bookingClinics,
        preselected_therapist: false,
        isExpert: this.bookingIsExpert,
        bookings: this.bookings,
        type: this.flowType,
        service: this.fService,
        token: this.token,
        singleClinic: this.singleClinic,
        noExperts: this.noExperts,
        noBodyParts: this.noBodyParts,
        duration: this.duration,
      };

    if (this.preselected_therapist === 'true') {
      params['preselected_therapist'] = true;
    }

    localStorage.setItem(
      'selectedService',
      JSON.stringify(this.preSelectedService)
    );

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate(['/booking-visit'], navigationExtras);

    document.querySelector('.booking-steps').scrollIntoView({
      behavior: 'smooth',
    });
  }

  getTherapistServices() {
    this.route.queryParams.subscribe((params: Params) => {
      this.selectedTherapist = this.clinicTherapists;
    });
  }

  getAvailableServices() {
    this.availableServices = [];

    this.mainService
      .getServices(this.clinics.toString(), this.fService)
      .subscribe(this.handleServiceSuccess.bind(this));
  }

  handleServiceSuccess(servicesResponse) {
    const all_services = [].concat(...servicesResponse.response);

    // sort services
    all_services.sort((a, b) => {
      return a[1] > b[1] ? 1 : -1;
    });

    // if aalborg flow, show only one service
    this.showOneService(all_services);

    // filter expert services
    if (this.bookingIsExpert === 'false') {
      this.filteredServices = this.filteredServices.filter((service) => {
        return service.service_type !== 'KX';
      });

      // if no aalborg flow, filter first time booking services
      if (this.flowType !== this.flowName.aalborg) {
        this.isFysio = true;

        this.bookingFK(this.allBookings, all_services);
      }
    } else {

      if (this.allBookings.length > 0) {
        this.filteredServices = this.filteredServices.filter(
          (service) => service.is_fk === 0 && service.service_type === 'KX'
        );
      } else {
        this.filteredServices = this.filteredServices.filter(
          (service) => service.is_fk === 1 && service.service_type === 'KX'
        );
      }

      // filter only selected expert therapist services
      const expert_therapist = this.expertTherapist[0];
      const preselected_services = [];

        this.filteredServices = this.filteredServices.filter((service) => {
        expert_therapist.services.map((expert_services) => {
          if (
            expert_services.service_name === service.service_name &&
            preselected_services.find(
              (el) => el.service_name === service.service_name
            ) === undefined
          ) {
            preselected_services.push(service);
          }
        });
      });

      this.filteredServices = preselected_services;
    }

    this.processPreselect();
  }

  showOneService(services) {
    if (this.flowType === this.flowName.aalborg) {
      this.filteredServices = services.map((service) =>
        service.filter((el) => el.service_code === '9066')
      );
    } else {
      this.filteredServices = services;
    }
  }

  bookingFK(bookingFK, services) {
    if (bookingFK && bookingFK.length > 0) {
      this.filteredServices = services.filter(
        (service) =>
          service.is_fk === 0 && service.service_type !== 'KX'
      );
    } else {
      let services = this.filteredServices.filter(
        (service) =>
          service.is_fk === 1 && service.service_type !== 'KX'
      );

      if (services && services.length === 0) {
        this.filteredServices = services.filter(
          (service) =>
            service.is_fk === 1 && service.service_type !== 'KX'
        );
      } else {
        this.filteredServices = services;
      }
    }
  }

  processPreselect() {
    if (this.filteredServices && this.filteredServices.length === 0) {
      this.services = false;
    } else {
      setTimeout(() => {
        this.preselectService(this.filteredServices);
      }, 0);

      const have_HV = this.filteredServices.filter(
          (service) => service.service_type === 'HV'
        ),
        have_FK = this.filteredServices.filter(
          (service) => service.is_fk === 1
        );

      if (have_FK.length > 0) {
        this.firstTime = true;
      } else {
        this.firstTime = false;
      }

      if (have_HV.length > 0) {
        this.showReferral = true;
      } else {
        this.showReferral = false;
      }
    }
  }

  setDropdownSelection(event: any, service) {
    this.selectedTherapist = '';
    this.selectedDate = null;
    this.selectedDate2 = null;

    const selection = service.service_name;

    this.preSelectedService = service.service_name;

    if (this.fisiqClinics) {
      this.dropdownSelection =
        this.dropdownSelection !== selection ? selection : undefined;
    } else {
      this.dropdownSelection = selection;
    }

    this.duration = service.duration;

    this.selectedId = undefined;

    if (event.currentTarget) {

      if (event.currentTarget.classList.contains('item-fisiq-set')) {
        this.selectedService = null;
      } else {
        this.selectedService = service.service_name;
      }
    }
  }

  setDropdownSelection2(event: any) {
    this.dropdownSelection2 = event.target.innerHTML.trim();
  }

  goBack() {
    // back to body parts if superclinic + service flow

    if (this.preselected_therapist === 'true') {
      const params = {
        type: this.flowType,
        service: this.fService,
        superClinicId: this.superClinicId,
        token: this.token,
        singleClinic: this.singleClinic,
      };

      if (this.singleClinic === 'true') {
        params['clinics'] = this.clinics;
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      this.router.navigate(['/welcome'], navigationExtras);
    } else {
      this.notPreselectedBack();
    }
  }

  notPreselectedBack() {
    const params = {
      clinics: this.clinics,
      type: this.flowType,
      service: this.fService,
      superClinicId: this.superClinicId,
      token: this.token,
      singleClinic: this.singleClinic,
      noBodyParts: this.noBodyParts,
    };

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    if (this.flowType === this.flowName.aalborg) {
      this.router.navigate(['/body-parts'], navigationExtras);
    } else {

      if (this.noExperts === 'true') {
        this.checkBodyParts(navigationExtras);
      } else {
        this.router.navigate(['/expert'], navigationExtras);
      }
    }
  }

  checkBodyParts(navigationExtras) {
    if (this.noBodyParts === 'true') {
      this.router.navigate(['/offer-fysiq'], navigationExtras);
    } else {
      this.router.navigate(['/body-parts'], navigationExtras);
    }
  }

  openMessage(el) {
    $(el.target)
      .closest('.service-wrapper')
      .find('.info-message-container')
      .fadeIn();
  }

  closeMessage(el) {
    $('.info-message-container').fadeOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/service/service.component.ts